import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Copy, Check } from 'lucide-react';

/** Modal that reveals the shareable URL after server-side share-token mint. */
export function ShareEstimateDialog({ open, onOpenChange, shareUrl, copied, onCopy }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-[#DDE1E5] text-[#171A1D] max-w-md" data-testid="share-dialog" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="font-display font-semibold tracking-tight">
            Share Estimate
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[#8A929B] mt-1">
          Anyone with this link can view a read-only version of this estimate. No login required.
        </p>
        <div className="flex gap-2 mt-4">
          <Input
            readOnly
            value={shareUrl}
            className="bg-white border-[#DDE1E5] text-[#171A1D] text-sm"
            data-testid="share-url-input"
          />
          <Button
            onClick={onCopy}
            className="shrink-0 bg-[#527F19] hover:bg-[#3F6114] text-white"
            data-testid="copy-share-link-btn"
          >
            {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
